import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { PanelArtifactVersion, SessionArtifact } from './rosArtifacts'
import { MicroAppDock } from './MicroAppDock'

interface AppArtifactRendererProps {
  artifact: SessionArtifact
  version: PanelArtifactVersion
  apiBaseUrl: string
  token: string | null
}

/**
 * Format-specific body renderer for an App Artifact. The surrounding title, version history,
 * actions, resize behavior, and close controls all remain owned by ArtifactPreviewPanel, just as
 * they are for Website, Survey, and Markdown artifacts.
 */
export function AppArtifactRenderer({
  artifact,
  version,
  apiBaseUrl,
  token,
}: AppArtifactRendererProps) {
  const definitionId = version.summary?.definitionId
  if (typeof definitionId !== 'string') {
    return (
      <Box sx={{ p: 3 }}>
        <Typography sx={{ color: 'text.secondary', fontSize: '0.85rem' }}>
          This App Artifact version is missing its runtime reference.
        </Typography>
      </Box>
    )
  }

  return (
    <MicroAppDock
      key={`${artifact.id}:${version.version}`}
      definitionId={definitionId}
      artifactVersion={version.version}
      displayName={artifact.title}
      apiBaseUrl={apiBaseUrl}
      token={token}
      autoPrepare
    />
  )
}
